<template>
  <div>
    <v-card>
      <div class="chart-conf">
        <reports-heading
          :total="getIssuedCertificates.total"
          title="Issued certificates"
          tooltip="Statistics related to certificates issued by selected CA and time period."
          @callSetReports="callSetReports"
        />
      </div>
      <div>
        <div class="chart-div">
          <v-container class="chart-container">
            <div id="chart">
              <div v-if="getIssuedCertificates.total === 0" class="empty-chart">
                <span>
                  <strong> Total 0 </strong>
                </span>
              </div>
              <div>
                <apexchart
                  v-if="getIssuedCertificates.total !== 0"
                  type="pie"
                  :class="getIssuedCertificates.total === 0 ? 'no-data-style' : ''"
                  :options="issuedCertificates__reportData.chartOptions"
                  :series="issuedCertificates__reportData.series"
                ></apexchart>
              </div>
            </div>
          </v-container>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ReportsHeading from "@/components/reports/reports-items/reports-heading.vue";

export default {
  name: "reports-issued-certificates",
  components: { ReportsHeading },
  mounted() {
    this.injectNewDataToChart();
  },
  methods: {
    ...mapActions(["updateIssuedCertificates"]),
    callSetReports(payload) {
      this.updateIssuedCertificates(payload.params).then(() => {
        this.loader = false;
        this.injectNewDataToChart();
      });
    },
    injectNewDataToChart() {
      this.issuedCertificates__reportData.series = [];

      this.issuedCertificates__reportData.series.push(
        this.getIssuedCertificates.total === 0
          ? 0
          : (this.getIssuedCertificates.notYetValid * 100) /
              this.getIssuedCertificates.total
      );
      this.issuedCertificates__reportData.series.push(
        this.getIssuedCertificates.total === 0
          ? 0
          : (this.getIssuedCertificates.active * 100) / this.getIssuedCertificates.total
      );
      this.issuedCertificates__reportData.series.push(
        this.getIssuedCertificates.total === 0
          ? 0
          : (this.getIssuedCertificates.revoked * 100) / this.getIssuedCertificates.total
      );
      this.issuedCertificates__reportData.series.push(
        this.getIssuedCertificates.total === 0
          ? 0
          : (this.getIssuedCertificates.expired * 100) / this.getIssuedCertificates.total
      );

      this.issuedCertificates__reportData.chartOptions.labels[0] =
        "Not active yet: " + this.showInFixedForm(this.getIssuedCertificates.notYetValid);
      // " " +
      // this.showInPercentage(this.getIssuedCertificates.notYetValid);

      this.issuedCertificates__reportData.chartOptions.labels[1] =
        "Active: " + this.showInFixedForm(this.getIssuedCertificates.active);
      // " " +
      // this.showInPercentage(this.getIssuedCertificates.active);

      this.issuedCertificates__reportData.chartOptions.labels[2] =
        "Revoked: " + this.showInFixedForm(this.getIssuedCertificates.revoked);
      // " " +
      // this.showInPercentage(this.getIssuedCertificates.revoked);

      this.issuedCertificates__reportData.chartOptions.labels[3] =
        "Expired: " + this.showInFixedForm(this.getIssuedCertificates.expired);
      // " " +
      // this.showInPercentage(this.getIssuedCertificates.expired);
    },
    showInFixedForm(number) {
      return Math.abs(number) > 999
        ? Math.sign(number) * (Math.abs(number) / 1000).toFixed(1) + "K"
        : Math.sign(number) * Math.abs(number);
    },
    // showInPercentage(number) {
    //   if (this.getIssuedCertificates.total === 0) {
    //     return "(0%)";
    //   } else {
    //     return "(" + Math.round((number * 100) / this.getIssuedCertificates.total) + "%)";
    //   }
    // },
    testsize() {
      console.log(this.$vuetify.breakpoint);
    },
  },
  computed: {
    ...mapGetters(["getIssuedCertificates"]),
  },
  data() {
    return {
      issuedCertificates__reportData: {
        series: [],
        chartOptions: {
          plotOptions: {
            pie: {
              customScale: 1,
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (val) {
                return "";
              },
              title: {
                formatter: (seriesName) => seriesName,
              },
            },
            onDatasetHover: {
              highlightDataSeries: true,
            },
          },
          // Doesn't work
          // toolbar: {
          //   show: true,
          //   tools: {
          //     download: true,
          //   }
          // },

          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val.toFixed(1) + "%";
            },
            dropShadow: {
              enabled: true,
            },
            style: {
              fontSize: "12px",
            },
            offsetY: 12,
          },
          labels: ["Not active yet", "Active", "Revoked", "Expired"],
          colors: ["#BAC0C5", "#54797A", "#000000", "#902123"],
          fill: { opacity: 1 },
          legend: {
            show: true,
            position: "bottom",
            horizontalAlign: "center",
            labels: {
              colors: "black",
              formatter: function (seriesName) {
                return seriesName;
              },
            },
            // fontSize: "12px",
            offsetX: -4,
            // offsetY: 30,
            markers: {
              width: 10,
              height: 10,
              radius: 2,
              offsetX: -4,
            },
            itemMargin: {
              vertical: 2,
            },
          },
          responsive: [
            {
              // Mobile screen
              breakpoint: 600,
              options: {
                chart: {
                  width: "300",
                },
                legend: {
                  position: "bottom",
                  offsetY: 4,
                },
              },
            },
            {
              // Medium screens
              breakpoint: 960,
              options: {
                chart: {
                  width: "360",
                },
                legend: {
                  position: "bottom",
                  offsetY: 4,
                },
              },
            },
            {
              breakpoint: 1350,
              options: {
                chart: {
                  width: "300",
                },
                legend: {
                  position: "bottom",
                  offsetY: 4,
                },
              },
            },
            {
              // Laptop screens
              breakpoint: 2000,
              options: {
                chart: {
                  width: "400",
                },
                legend: {
                  position: "bottom",
                  offsetY: 4,
                },
              },
            },
          ],
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22.3rem;
  width: 100%;
}

@media only screen and (min-width: 1000px) {
  .chart-div {
    height: 22.3rem;
  }
}

// @media only screen and (max-width: 1360px) {
//   .chart-div {
//     // height: 36.9vh
//     height: 22.188rem;
//   }
// }

// @media only screen and (max-width: 1360px)
//   .chart-div
//     // height: 36.9vh
//     height: 41.8vh

// @media only screen and (max-width: 1800px) {
//   .chart-div {
//     height: 47.5vh;
//   }
// }
// @media only screen and (min-width: 1800px) {
//   .chart-div {
//     height: 36.9vh;
//   }
// }
// @media only screen and (min-width: 1920px)
//   .chart-div
//     height: 41.6vh

.empty-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-color: #ccc;
  opacity: 0.5;
}
.apexcharts-canvas {
  margin: auto !important;
}
.apexcharts-legend-text:after {
  content: none !important;
}
</style>
